import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import { REPLAY_GREETING_EVENT } from "./components/HeroGreeting";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import News from "./components/News";
import SocialFollow from "./components/SocialFollow";
import MeetingForm from "./components/MeetingForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { company } from "@/mocks/home";

function FloatingActions() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-center gap-3">
      {showTop && (
        <button
          type="button"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            window.dispatchEvent(new Event(REPLAY_GREETING_EVENT));
          }}
          aria-label="Voltar ao topo"
          className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 hover:text-primary-600"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      )}
      <a
        href={company.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com a Porta31 no WhatsApp"
        className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-all duration-300 hover:scale-110 hover:bg-primary-600 dark:text-foreground-950"
      >
        <i className="ri-whatsapp-line text-2xl" aria-hidden="true" />
      </a>
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <News />
        <SocialFollow />
        <MeetingForm />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}